import styled from "styled-components";
import "../../styles/variables.css";

export const SpectralButton = styled.button<{
  width?: string;
  height?: string;
}>`
  cursor: pointer;
  width: ${(props) => props.width || "180px"};
  height: ${(props) => props.height || "30px"};
  border-radius: 50px;
  border-color: transparent;
  opacity: 0.9;
  background-clip: padding-box, border-box;
  background-image: linear-gradient(
      var(--bg-dark-button),
      var(--bg-dark-button)
    ),
    linear-gradient(
      257.92deg,
      var(--orange-20) 5.36%,
      var(--orange-10) 55.62%,
      var(--blue-10) 89.97%
    );
  background-origin: border-box;
  span {
    color: var(--white);
    font-weight: 600;
    font-size: var(--fs16);
  }
`;
